import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/teacher-rank`;

export const teacherRankRoutesObj = {
  list: baseRoute,
} as const;

export type ITeacherRankRouteParams = IExtractRouteParamMap<
  typeof teacherRankRoutesObj
>;

export const teacherRankPath = createPaths<
  typeof teacherRankRoutesObj,
  ITeacherRankRouteParams
>(teacherRankRoutesObj);
